import { render } from "./incident_comment_item.html?vue&type=template&id=db04054e&external"
import script from "./incident_comment_item.js?vue&type=script&lang=js&external"
export * from "./incident_comment_item.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__